import { Injectable } from '@angular/core';
import { LaunchDarklyService } from './launchdarkly.service';
import { AZURE_DOCUMENT_INTELLIGENCE_EARLY_CLASSIFICATION_UI_FLAG, STEP_LABELS } from '../utils/constants';

export type StepLabelGroup = keyof typeof STEP_LABELS;

/**
 * Single source of truth for digitization step labels, which differ between the
 * legacy flow and the Azure early-classification flow. Centralizing the flag
 * lookup and label-key resolution guarantees the stepper, navigation menus and
 * status popovers all render the same label for a given step.
 */
@Injectable({
  providedIn: 'root'
})
export class StepLabelService {

  constructor(private _launchDarklyService: LaunchDarklyService) { }

  get isEarlyClassificationEnabled(): boolean {
    return !!this._launchDarklyService.flags[AZURE_DOCUMENT_INTELLIGENCE_EARLY_CLASSIFICATION_UI_FLAG];
  }

  getStepLabel(group: StepLabelGroup): string {
    const labelKey = this.isEarlyClassificationEnabled ? 'earlyClass' : 'legacy';
    return STEP_LABELS[group][labelKey];
  }

}
